import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-import-modal',
  templateUrl: './modal-import.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalImportComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalImportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}